// © 2026 Buddy Media LLC. All rights reserved.
import { Navigate, Route, Routes } from "react-router-dom";
import { AppShell } from "@/layout/AppShell";
import { ClusterPulsePage } from "@/pages/ClusterPulsePage";
import { LoginPage } from "@/pages/LoginPage";
import { AdminLoginPage } from "@/pages/AdminLoginPage";
import { OperationsCredentialsPage } from "@/pages/OperationsCredentialsPage";
import { OperationsClusterTopologyPage } from "@/pages/OperationsClusterTopologyPage";
import { QStreamPage } from "@/pages/QStreamPage";
import { OpsTokenBudgetPage } from "@/pages/OpsTokenBudgetPage";
import { MergeDaemonPage } from "@/pages/MergeDaemonPage";
import { ShadowOrchestratorPage } from "@/pages/ShadowOrchestratorPage";
import { InitiativeDigestsPage } from "@/pages/InitiativeDigestsPage";
import { ServiceAccountsPage } from "@/pages/ServiceAccountsPage";
import { OpsAgentsPage } from "@/pages/OpsAgentsPage";
import { OperationalSecretsPage } from "@/pages/OperationalSecretsPage";
import {
  OperationsBackendWorkerPage,
  OperationsFrontendWorkerPage,
  OperationsWireTestWorkerPage,
} from "@/pages/OperationsWorkerPage";
import { useAuthStore } from "@/store/authStore";

export function App() {
  const bearer = useAuthStore((s) => s.bearer);
  return (
    <Routes>
      <Route path="/login" element={<LoginPage />} />
      {/* T-678 Phase 3 prep — magic-link consumer for MCP admin auth.
          MCP server (T-679) emails Marc a link of shape
          /admin-login?token=XXX after he requests one. */}
      <Route path="/admin-login" element={<AdminLoginPage />} />
      <Route
        path="/"
        element={
          bearer ? <AppShell /> : <Navigate to="/login" replace />
        }
      >
        <Route index element={<Navigate to="/cluster-pulse" replace />} />
        <Route path="cluster-pulse" element={<ClusterPulsePage />} />

        {/* T-615 Phase 2 — migrated MCP admin leaves. URL paths
            preserve the legacy /admin/operations/* shape so any
            existing operator bookmarks redirect cleanly via the
            cross-link banner in dev-buddywatch-frontend-desktop. */}
        <Route path="credentials" element={<OperationsCredentialsPage />} />
        <Route path="cluster-topology" element={<OperationsClusterTopologyPage />} />
        <Route path="q-stream" element={<QStreamPage />} />
        <Route path="token-budget" element={<OpsTokenBudgetPage />} />
        <Route path="merge-daemon" element={<MergeDaemonPage />} />
        <Route path="shadow-orchestrator" element={<ShadowOrchestratorPage />} />
        <Route path="initiative-digests" element={<InitiativeDigestsPage />} />
        <Route path="service-accounts" element={<ServiceAccountsPage />} />
        <Route path="ops-agents" element={<OpsAgentsPage />} />
        <Route path="secrets" element={<OperationalSecretsPage />} />
        <Route path="backend-worker" element={<OperationsBackendWorkerPage />} />
        <Route path="frontend-worker" element={<OperationsFrontendWorkerPage />} />
        <Route path="wire-test-worker" element={<OperationsWireTestWorkerPage />} />
      </Route>
    </Routes>
  );
}
